import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LabelComponent extends Component {
  static readonly TYPE_ID: string = 'bff9578232a443148e55e6b0fcedfdaa';

  constructor(
    public readonly labels: LocalizedString,
  ) {
    super();
  }

  get $typeId(): string {
    return LabelComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LabelComponent {
    return new LabelComponent(
        context.fromData<LocalizedString>(MapUtils.getRaw(map, 'labels') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'labels': context.toData(this.labels),
    };
  }

  clone(): this {
    return new LabelComponent(
        this.labels.clone(),
    ) as this;
  }

  isSame(other: LabelComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.labels, this.labels);
  }
}

export class LabelComponentBuilder extends DataModelBuilder<LabelComponent> {
  build(context: SerializationContext, map: SerializedData): LabelComponent {
    return LabelComponent.fromMap(context, map);
  }
}
